<template>
    <a-drawer
      :title="'科研项目-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="40%"
    >
        <div class="input-box">
            <p>项目名称：</p>
            <a-input class="input" v-model="info.projectName" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>项目金额：</p>
            <a-input class="input" v-model="info.projectAmount" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>批准时间：</p>
            <a-date-picker class="input"  valueFormat="YYYY-MM-DD" v-model="info.approveDate" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>下达部门：</p>
            <a-input class="input" v-model="info.issuingDept" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>项目性质名称：</p>
            <a-input class="input" v-model="info.projectNature" :disabled="actionName=='查看'"/>
        </div>
         <div class="input-box">
            <p>进展情况名称：</p>
            <a-select class="input" allowClear v-model="info.projectProgress" :disabled="actionName=='查看'">
                <a-select-option  value="结题验收">结题验收</a-select-option>
                <a-select-option  value="立项">立项</a-select-option>
                <a-select-option  value="进行中">进行中</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>承担责任名称：</p>
            <a-select class="input" allowClear v-model="info.responsibleName" :disabled="actionName=='查看'">
                <a-select-option  value="主要承担者">主要承担者</a-select-option>
                <a-select-option  value="负责人">负责人</a-select-option>
                <a-select-option  value="参与者">参与者</a-select-option>
            </a-select>
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="draft" v-if="actionName!='查看'">暂存</a-button>
            <a-button type="primary" @click="commit" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { addResearch,getResearch,updateResearch } from '@/baseAPI/postdoctor'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                doctorId:'',
                info:{
                    id:"",
                    doctorId:"",
                    projectName: "",
                    projectAmount: "",
                    approveDate: "",
                    issuingDept: "",
                    projectNature: "",
                    projectProgress: "",
                    responsibleName: "",
                    approvalStatus:"draft"
                },
                xmjbArr:[],
                jsArr:[],
                yearShowOne:false,
            }
        },
        mounted () {
        },
        methods:{
            draft(){
                this.info.approvalStatus = 'draft'
                this.sub()
            },
            commit(){
                this.info.approvalStatus = 'commit'
                this.sub()
            },
            getInfo(){
                if(this.actionName!='新增'){
                    getResearch(this.doctorId).then(res=>{
                        res.data.forEach(element => {
                            if(element.id == this.id){
                                this.info = element;
                            }
                        });
                    })
                }
            },
            showDrawer(name,doctorId,id){
                this.id=id;
                this.doctorId = doctorId;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={}
                this.visible = false;
                this.$parent.getResearch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                // console.log(this.info)
                // var arr=['remark','approvalStatus','courseAttrName']
                // for(let key in this.info){
                //     if(arr.indexOf(key)<0){
                //         if(this.info[key]==null||this.info[key]===''){
                //             isSub=false;
                //             break;
                //         }
                //     }
                // }
                if(isSub){
                    this.info.doctorId = this.doctorId;
                    if(this.actionName=='新增'){
                        addResearch(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增科研项目成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        updateResearch(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改科研项目成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            openChangeOne(status) {
                if (status){
                    this.yearShowOne =  true
                }
            },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.info.decideDate = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            }

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 15rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 15rem);
    }
    .input-box .tips{
        width: calc(100% - 15rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
